import Shippings from "./Shippings";
export default Shippings;
